import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SearchService } from '@services/search.service';
import { RouteService } from '@services/route.service';

@Component({
  selector: 'gob-search-home',
  templateUrl: './search-home.component.html',
  styleUrls: ['./search-home.component.scss']
})
export class SearchHomeComponent implements OnInit, AfterViewInit {

  @ViewChild('videoPlayer') videoPlayer: ElementRef;
  defaultVideo = 'graoully.mp4';
  eventVideo = 'summer-sales.mp4';
  defaultButton = 'default';
  eventButton = 'sales';

  source: string;
  button: string;

  // ON SÉPARE LE TITRE EN DEUX LIGNES FIXES
  titreLigne1: string = 'BIENVENUE À';
  titreLigne2: string = 'LA CAVERNE DU GOBELIN';

  sousTitre: string = 'Explorez l\'univers du jeu sous toutes ses formes';

  boutonText: string = 'Découvrir notre univers';
  boutonLien: string = '/notre-univers';

  motsLigne1: string[][] = [];
  motsLigne2: string[][] = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public search: SearchService,
    public route: RouteService) { }

  ngOnInit(): void {
    this.setElementsByDate();
    // On découpe chaque ligne séparément
    this.motsLigne1 = this.decouperTexte(this.titreLigne1);
    this.motsLigne2 = this.decouperTexte(this.titreLigne2);
  }

  onVideoClick(): void {
    if (this.button === this.defaultButton) { return; }
    this.route.navigate('products-list', ['banner', '671e72361fd0a', 'promotions']);
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.videoPlayer && this.videoPlayer.nativeElement) {
        this.videoPlayer.nativeElement.muted = true;
        this.videoPlayer.nativeElement.play().catch((err: any) => {
          console.log('Autoplay bloqué :', err);
        });
      }
    }
  }

  private decouperTexte(texte: string): string[][] {
    return texte.split(' ').map(mot => mot.split(''));
  }

  private setElementsByDate(): void {
    const today = new Date();

    // Example rule: autoplay sales video until a given date
    const videoEndDate = new Date('2026-07-21T23:59:59'); // event video end date

    this.source = today <= videoEndDate ? this.eventVideo : this.defaultVideo;
    this.button = today <= videoEndDate ? this.eventButton : this.defaultButton;
  }
}
